import React, {useEffect, useState, useRef} from 'react';
import { Navbar, Nav, Button, NavDropdown} from 'react-bootstrap';
import logo from "../assets/cropped-Negro-371x176.png"
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';


const Header = () => {
  const location = useLocation();
  const isInvestigaciones = location.pathname.toLowerCase() === '/investigaciones';

  const WPIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 27"
      className="icono-wp-white-header"
    >
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"></path>
    </svg>
  );
    
    const phoneNumber = '541150520070';
    const phoneNumberInv = '541128441659';
    const phoneNumberText = '(011) 5052-0070';
    const phoneNumberInvText = '(011) 2844-1659';     
    const message = 'Hola ARMAT03, estoy interesado en sus servicios de seguridad. Me gustaría que me contacten!';
  
    const WhatsApp = ({ phone, message,phoneText }) => {
      const link = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(message)}`;

      return (
        <Button
        variant="btn btn-xlg" 
        className="btn-orange btn-sm"
        style={{ color: 'white', textDecoration: 'none' }}
        onMouseEnter={(e) => (e.currentTarget.style.color = 'white')}
        onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
        href={link}
      >
        <p className="buttonNav cotiza-responsive cotiza">COTIZÁ AHORA</p>
                <h3 className='text-white fw-bold num-responsive'>
                  <WPIcon className='justify-self-end aling-self-end' />
                  {phoneText}
                </h3>
        </Button>
      );

    };

    const WhatsAppInv = ({ phone, message,phoneText }) => {
      const link = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(message)}`;

      return (
        <Button
        variant="btn btn-xlg" 
        className="btn-inv btn-sm"
        style={{ color: 'white', textDecoration: 'none' }}
        onMouseEnter={(e) => (e.currentTarget.style.color = 'white')}
        onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
        href={link}
      >
        <p className="buttonNav cotiza-inv cotiza-responsive text-white">CONSULTA POR INVESTIGACIÓN</p>
                <h3 className='text-white fw-bold num-responsive'>
                  <WPIcon className='justify-self-end aling-self-end' />
                  {phoneText}
                </h3>
        </Button>
      );

    };

    const [isNavCollapsed, setIsNavCollapsed] = useState(false);

    const handleNavToggle = () => setIsNavCollapsed(!isNavCollapsed);
    const handleNavLinkClick = () => {
      setIsNavCollapsed(false);
      setShowServicios(false);
    };

    const [showServicios, setShowServicios] = useState(false);

    const navbarRef = useRef(null); 
    const touchStartRef = useRef(null);

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (navbarRef.current && !navbarRef.current.contains(event.target)) {
          setIsNavCollapsed(false);
        }
      };
      
      document.addEventListener("mousedown", handleOutsideClick);
      
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }, []);

    useEffect(() => {
      const handleTouchStart = (event) => {
          touchStartRef.current = event.touches[0].clientY; 
      };

      const handleTouchEnd = (event) => {
          const touchEndY = event.changedTouches[0].clientY; 
          const touchDiff = touchStartRef.current - touchEndY; 

          
          if (Math.abs(touchDiff) > 50) {
              setIsNavCollapsed(false);
          }
      };

      document.addEventListener("touchstart", handleTouchStart);
      document.addEventListener("touchend", handleTouchEnd);

      return () => {
          document.removeEventListener("touchstart", handleTouchStart);
          document.removeEventListener("touchend", handleTouchEnd);
      };
  }, []);
    
    const isSmallScreen = useMediaQuery({ maxWidth: 991 });
    const navItems = () =>(
      <>
        {/*
        <Nav.Item className='mx-2'> 
          <Nav.Link as={Link} to="/" eventKey="/" className="text-white text-center resposive-nav" onClick={handleNavLinkClick}>INICIO</Nav.Link>
        </Nav.Item>
        */}

        <Nav.Item>
          <Nav.Link eventKey="/Nosotros" as={Link} to="/Nosotros" className="nav-text text-center resposive-nav" onClick={handleNavLinkClick}>Nosotros</Nav.Link>
        </Nav.Item> 

        <NavDropdown
          title="Servicios"
          id="nav-servicios"
          className="nav-text text-center resposive-nav"
          active={['/servicios', '/investigaciones'].includes(location.pathname.toLowerCase())}
          show={showServicios}
          onToggle={(isOpen) => setShowServicios(isOpen)}
          onMouseEnter={() => !isSmallScreen && setShowServicios(true)}
          onMouseLeave={() => !isSmallScreen && setShowServicios(false)}
        >
          <NavDropdown.Item as={Link} to="/Servicios" onClick={handleNavLinkClick} active={location.pathname.toLowerCase() === '/servicios'}>
            Guardias y vigilancia
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/Investigaciones" onClick={handleNavLinkClick} active={location.pathname.toLowerCase() === '/investigaciones'}>
            Investigaciones
          </NavDropdown.Item>
        </NavDropdown>
        
        <Nav.Item>
          <Nav.Link eventKey="/ArmatControl" as={Link} to="/ArmatControl" className="nav-text text-center resposive-nav" onClick={handleNavLinkClick}>Armat Control</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="/Contacto" as={Link} to="/Contacto" className="nav-text text-center resposive-nav" onClick={handleNavLinkClick}>Contacto</Nav.Link>
        </Nav.Item>
      </>
    )

    return (       
      <Navbar expand="lg" className="custom-color-nav naveg" expanded={isNavCollapsed} ref={navbarRef}>
          <Navbar.Brand>
              <Nav.Link eventKey="/" as={Link}  to="/"  onClick={handleNavLinkClick}>
                <img src={logo} alt="logo" className="mx-2 img-logo" style={{ maxWidth: '250px'}} />
              </Nav.Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" onClick={handleNavToggle} />
          <Navbar.Collapse id="navbarScroll" className="fs-3">
              <Nav
                  className="me-auto my-2 my-lg-0 d-flex justify-content-center align-items-center text-center gap-responsive "
                  variant="pills"
                  activeKey={location.pathname}
                  >
                {isSmallScreen ? (
                    <div className="collapse-font">
                      {navItems()}
                    </div>
                  ) : (
                    navItems()
                  )}
              </Nav>
              <Nav className="mx-3"  >
                <Nav.Item>
                  <div className="d-flex justify-content-sm-center me-2 wp-button-container" >
                    {isInvestigaciones ? (
                      <WhatsAppInv phone={phoneNumberInv} message={message} phoneText={phoneNumberInvText}/>
                    ) :(
                      <WhatsApp phone={phoneNumber} message={message} phoneText={phoneNumberText}/>
                    )}
                  </div>
                </Nav.Item>
              </Nav>
          </Navbar.Collapse>
  </Navbar>
  
     );
}
 
export default Header;